import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import EfficiencyBar from "@/components/site/EfficiencyBar";
import Services from "@/components/site/Services";
import PalletTypes from "@/components/site/PalletTypes";
import Quality from "@/components/site/Quality";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Home() {
  const [preselected, setPreselected] = useState(null);

  useEffect(() => {
    document.title = "Vigopal · Pallets para tu operación industrial";
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <EfficiencyBar />
        <Services />
        <PalletTypes onSelectType={setPreselected} />
        <Quality />
        <QuoteForm preselected={preselected} onConsumePreselect={() => setPreselected(null)} />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
